import script from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeItemThumbnail.vue?vue&type=style&index=0&id=8603ad34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8603ad34"]])

export default __exports__